<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M19 7.93932L34.8839 22.3516L19 36.7638V31V30.25H18.25H6.75V14.75H18.25H19V14V7.93932Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
